import { motion } from 'framer-motion';

/**
 * Splash di apertura: simbolo Manteco grande + wordmark + payoff.
 * Overlay fixed che copre l'intero viewport, durata ~1.8s.
 *
 * Stagger pensato per dare un ritmo cinematic:
 *   0.0 - 0.6s  simbolo fade-in + scale
 *   0.3 - 0.8s  wordmark "manteco" fade-in
 *   0.5 - 1.0s  payoff "Optimize your restaurant" fade-in
 *   1.0 - 1.5s  pause cinematic
 *   1.5+        smonta — il componente padre toglie dall'AnimatePresence
 *
 * L'exit (opacity 0 + slight scale) è gestito automaticamente da Framer
 * quando il padre rimuove il componente.
 */
export function SplashScreen() {
  return (
    <motion.div
      key="splash"
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, scale: 1.03 }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      className="fixed inset-0 z-[100] bg-background flex flex-col items-center justify-center gap-7"
      aria-hidden="true"
    >
      {/* Simbolo */}
      <motion.svg
        initial={{ opacity: 0, scale: 0.86, y: 6 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        width="120"
        height="120"
        viewBox="12 12 96 96"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Manteco"
      >
        <g transform="translate(60,60)">
          <path
            d="M0 -16 L0 -48 A48 48 0 0 1 48 0 L16 0 A16 16 0 0 0 0 -16 Z"
            fill="#C23535"
          />
          <path
            d="M16 0 L43 0 A43 43 0 0 1 0 43 L0 16 A16 16 0 0 0 16 0 Z"
            fill="#501313"
          />
          <path
            d="M0 16 L0 39 A39 39 0 0 1 -39 0 L-16 0 A16 16 0 0 0 0 16 Z"
            fill="#E24B4A"
          />
          <path
            d="M-16 0 L-45 0 A45 45 0 0 1 0 -45 L0 -16 A16 16 0 0 0 -16 0 Z"
            fill="#791F1F"
          />
        </g>
      </motion.svg>

      {/* Wordmark */}
      <motion.p
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55, delay: 0.28, ease: [0.16, 1, 0.3, 1] }}
        className="text-4xl font-semibold tracking-tight leading-none"
      >
        manteco
      </motion.p>

      {/* Payoff */}
      <motion.p
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
        className="-mt-3 text-[11px] uppercase tracking-[0.28em] text-muted-foreground"
      >
        Il Tuo F&amp;B Manager Virtuale...
      </motion.p>
      {/* Payoff allineato al positioning F&B Manager virtuale (vedi
          marketing/index.html). Aggiornato dopo i 5 build F&B. */}
    </motion.div>
  );
}
